import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Grid, Badge } from '@material-ui/core';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';


const Header = () => {


    return (
        <AppBar position="static">
            <Toolbar>
                {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                    <MenuIcon />
                </IconButton> */}
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justify="space-between"
                >
                    <Grid item spacing={10}>
                        <Typography variant="h6" component="h1" >
                            Toy Mart
          </Typography>
                    </Grid>
                    <Button color="inherit" >
                        <Badge badgeContent={0}>
                            <ShoppingCartIcon />
                        </Badge>
                    </Button>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};

export default Header;